import {RecordForm} from '../forms/RecordForm';


import {useAccountApplication} from '../hooks/useAccountApplication.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate, useParams} from "react-router-dom";
import {AccountApplication} from "../types.ts";


export const AddPage = () => {

    const {id: accountId} = useParams()

    if (!accountId) {
        throw new Error('Account ID is required');
    }

    const navigate = useNavigate();

    const {
        record,
        createRecord,
    } = useAccountApplication();

    const onCancel = () => {
        navigate(`/accounts/${accountId}`);
    };

    return (
        <FormPageLayout
            title='Add Account Application'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={record || {} as AccountApplication} handleSubmit={createRecord} handleCancel={onCancel}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
